<template>
    <div class="mt-5">
        <div class="d-flex justify-content-between pt-2">
            <h4 class="pt-3">
                <div class="btn-group">
                    <button type="button" class="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        {{
                            typeGraficsResum === 'person' || !typeGraficsResum ? 'Resumo de Pessoas' : 'Resumo de Clientes'
                        }}
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" @click="changeType('person')">Resumo de Pessoas</a>
                        <a class="dropdown-item" @click="changeType('client')">Resumo de Clientes</a>
                    </div>
                </div>
            </h4>
            <div class="d-flex flex-row">
                <label class="align-self-center mr-1">Loteamentos:</label>
                <Select2 :options="[{id:'nenhum', text:'Nenhum'},...allotmentsOnlyUserAllo]"
                         v-if="allotmentsOnlyUserAllo?.length" class="align-self-center"
                         v-model="allotmentId" @select="changeAllotment"
                         :settings="{width:'13vw'}" placeholder="Selecione"
                ></Select2>
            </div>
        </div>
        <div v-show="typeGraficsResum === 'person'">
            <div class="d-flex flex-row" style="gap: 8px;">
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumM')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartMaritalStatus">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientMaritalStatus"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumA')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartAge">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientAge"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumS')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartSex">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientSex"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumT')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartType">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientType"></div>
                    <p class="justify-content-center d-flex m-0 p-0" v-if="!loadingChartType"><b>Total:
                        {{ totalClient }}</b></p>
                </div>
            </div>
            <div class="d-flex flex-row" style="gap: 8px;">
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumSt')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartState">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientState"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumIn')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartIncome">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientIncome"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumPr')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartProfession">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientProfession"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card p-2" :style="loadingGrafic('resumCi')">
                        <div class="spinner-border align-self-center" role="status" v-if="loadingChartCity">
                            <span class="sr-only"></span>
                        </div>
                        <div id="clientCity"></div>
                        <div id="legendCity" v-show="!loadingChartCity"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="typeGraficsResum === 'client'">
            <div class="d-flex flex-row" style="gap: 8px;">
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumMClient')">
                    <div class="spinner-border align-self-center" role="status"
                         v-if="loadingChartClientReserveMaritalStatus">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientReserveMaritalStatus"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumAClient')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartClientReserveAge">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientReserveAge"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumSClient')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartReserveSex">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientReserveSex"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumTClient')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartClientReserveType">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientReserveType"></div>
                    <p class="justify-content-center d-flex m-0 p-0"
                       v-if="!loadingChartClientReserveType"><b>Total: {{ totalReserveClient }}</b></p>
                </div>
            </div>
            <div class="d-flex flex-row" style="gap: 8px;">
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumStClient')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartClientReserveState">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientReserveState"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumInClient')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartClientIncome">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientReserveIncome"></div>
                </div>
                <div class="card pt-1 flex-grow-1" style="flex-basis: 0;" :style="loadingGrafic('resumPrClient')">
                    <div class="spinner-border align-self-center" role="status" v-if="loadingChartReserveClientProfession">
                        <span class="sr-only"></span>
                    </div>
                    <div id="clientReserveProfession"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card p-2" :style="loadingGrafic('resumCiClient')">
                        <div class="spinner-border align-self-center" role="status" v-if="loadingChartReserveClientCity">
                            <span class="sr-only"></span>
                        </div>
                        <div id="clientReserveCity"></div>
                        <div id="legendReserveCity" v-show="!loadingChartReserveClientCity"></div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="card p-2 " style="height: 61vh" :style="loadingGrafic('progress')">
                <div class="d-flex flex-row justify-content-between" v-if="!loadingChartProgress">
                    <div v-if="!widthMd(1046)"></div>
                    <div v-if="!widthMd(1046)"></div>
                    <h4 class="text-center">{{ t('GENERAL.MSG.PROGRESS_REGISTER_CLIENTS') }}</h4>
                    <div class="d-flex flex-row" v-if="!widthMd(1046)">
                        <div class="pr-2" style="width: 170px">
                            <div class="form-group mb-0">
                                <label> Período Inicial:</label>
                                <input type="date" class="form-control" v-model="dateStart"
                                       id="dateStart"
                                       @blur="changeDs">
                            </div>
                        </div>
                        <div class="pr-2" style="width: 170px">
                            <div class="form-group mb-0">
                                <label> Período Final:</label>
                                <input type="date" v-model="dateEnd" class="form-control"
                                       id="dateEnd"
                                       @blur="changeDE">
                            </div>
                        </div>
                        <div class="pr-2 align-self-end">
                            <button class="btn btn-primary" @click="alterDatesChartProgress">Aplicar</button>
                        </div>
                    </div>
                </div>
                <p class="text-right" style="color: red" v-if="!loadingChartProgress && !widthMd(1046)">Período Máximo
                    30
                    dias.</p>
                <div class="spinner-border align-self-center" role="status" v-if="loadingChartProgress">
                    <span class="sr-only"></span>
                </div>
                <div id="apex"></div>
            </div>
        </div>
        <modal modal-extra-large>
            <div class="modal-body">
                <div class="card pt-1 col-12">
                    <div id="clientNeighborhod"></div>
                    <div id="legendNeighborhod"></div>
                </div>
            </div>

        </modal>
    </div>
</template>

<script>

import Clients from "../../services/Clients";
import * as ApexCharts from "apexcharts";
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";
import Select2 from 'vue3-select2-component';
import {mapState} from 'vuex';
import moment from 'moment';
import modal from '../../components/modal';

export default {
    name: "dashboardClient",
    components: {Select2, modal},
    computed: {
        ...mapState({
            allotments: 'allotments',
            allotmentsOnlyUserAllo: 'allotmentsOnlyUserAllo',
        })
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    beforeRouteLeave(to, from, next) {
        this.destroyChartsPerson();
        this.destroyChartsReserveClient();
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
        next();
    },
    data() {
        return {
            allotmentId: null,
            typeGraficsResum: 'person',
            chartNeighborhood: null,
            dateStart: null,
            dateEnd: null,
            items: null,
            totalReserveClient: 0,
            totalClient: 0,
            filters: null,
            chart: null,
            chartSex: null,
            chartReserveClientType: null,
            loadingChartState: null,
            loadingChartIncome: null,
            loadingChartClientIncome: null,
            loadingChartReserveClientProfession: null,
            chartClientReserveIncome: null,
            loadingChartCity: null,
            loadingChartReserveClientCity: null,
            loadingChartProfession: null,
            chartReserveSex: null,
            chartAge: null,
            chartIncome: null,
            chartClientReserveAge: null,
            chartMaritalStatus: null,
            chartState: null,
            chartClientReserveState: null,
            chartProfession: null,
            chartReserveClientProfession: null,
            chartCity: null,
            chartReserveClientCity: null,
            chartClientType: null,
            chartClientReserveMaritalStatus: null,
            loadingChartProgress: null,
            loadingChartSex: null,
            loadingChartClientReserveType: null,
            loadingChartClientReserveState: null,
            loadingChartType: null,
            loadingChartReserveSex: null,
            loadingChartAge: null,
            loadingChartClientReserveAge: null,
            loadingChartMaritalStatus: null,
            loadingChartClientReserveMaritalStatus: null,
        }
    },
    unmounted() {
        this.destroyChartsPerson();
        this.destroyChartsReserveClient();
    },
    mounted() {
        this.$store.commit('changeLoading', true);
        setTimeout(() => this.$store.commit('changeLoading', false), 300)
        this.renderChart();
        this.renderChartsPerson();
    },
    methods: {
        changeType(type) {
            this.typeGraficsResum = type;
            if (type === 'client') {
                this.destroyChartsPerson();
                this.renderChartsReserveClient();
            } else {
                this.destroyChartsReserveClient();
                this.renderChartsPerson();
            }
        },
        renderChartsReserveClient() {
            this.graficResumClientReserveState();
            this.graficResumReserveClientType();
            this.graficResumClientReserveSex();
            this.graficResumClientReserveAge();
            this.graficResumClientReserveMaritalStatus();
            this.graficResumClientReserveIncome();
            this.graficResumClientReserveCity();
            this.graficResumClientReserveProfession();
        },
        renderChartsPerson() {
            this.graficResumClientState();
            this.graficResumClientIncome();
            this.graficResumClientProfession();
            this.graficResumClientCity();
            this.graficResumClientSex();
            this.graficResumClientType();
            this.graficResumClientAge();
            this.graficResumClientMaritalStatus();
        },
        destroyChartsPerson() {
            this.chartNeighborhood?.destroy();
            this.chartAge?.destroy();
            this.chartMaritalStatus?.destroy();
            this.chartState?.destroy();
            this.chartIncome?.destroy();
            this.chartCity?.destroy();
            this.chartProfession?.destroy();
            this.chartSex?.destroy();
            this.chartClientType?.destroy();
        },
        destroyChartsReserveClient() {
            this.chartNeighborhood?.destroy();
            this.chartReserveClientType?.destroy();
            this.chartReserveSex?.destroy();
            this.chartClientReserveAge?.destroy();
            this.chartClientReserveMaritalStatus?.destroy();
            this.chartClientReserveState?.destroy();
            this.chartClientReserveIncome?.destroy();
            this.chartReserveClientCity?.destroy();
            this.chartReserveClientProfession?.destroy();
        },
        alterDatesChartProgress() {
            this.renderChart();
        },
        changeDs() {
            if (moment(this.dateStart).isAfter(moment())) {
                this.dateStart = moment().format('YYYY-MM-DD');
            }
            let data = moment(this.dateStart);
            if (!this.dateEnd) {
                const data2 = data.add(30, 'days');
                if (data2.isAfter(moment())) {
                    this.dateEnd = moment().format('YYYY-MM-DD');
                    return
                }
                this.dateEnd = data2.format('YYYY-MM-DD');
                return
            }
            const data2 = moment(this.dateEnd);
            const diffDays = data2.diff(data, 'days');
            if (diffDays > 30) {
                this.dateEnd = data.add(30, 'days').format('YYYY-MM-DD');
            }
        },
        changeDE() {
            if (moment(this.dateEnd).isAfter(moment())) {
                this.dateEnd = moment().format('YYYY-MM-DD');
            }
            let data = moment(this.dateEnd);
            if (!this.dateStart) {
                const data2 = data.subtract(30, 'days');
                this.dateStart = data2.format('YYYY-MM-DD');
                return
            }
            const data2 = moment(this.dateStart);
            const diffDays = data.diff(data2, 'days');
            if (diffDays > 30) {
                this.dateStart = data.subtract(30, 'days').format('YYYY-MM-DD');
            }
        },
        widthMd(size = 1025, smaller = '<') {
            if (smaller == '<') {
                return window.innerWidth < size;
            } else {
                return window.innerWidth > size;
            }
        },
        changeAllotment() {
            this.dateStart = null;
            this.dateEnd = null;
            if (this.typeGraficsResum === 'person'){
                this.renderChartsPerson();
            }else {
                this.renderChartsReserveClient();
            }
            this.renderChart();
        },
        async index() {
            if (this.dateStart && this.dateEnd) {
                const data1 = moment(this.dateStart);
                const data2 = moment(this.dateEnd);
                if (data1.isAfter(data2)) {
                    let aux = this.dateStart;
                    this.dateStart = this.dateEnd;
                    this.dateEnd = aux;
                }
            }
            await Clients.dashboard(this.allotmentId, this.dateStart, this.dateEnd).then(resp => {
                this.dateRegisters = resp.data.dateRegisters;
                this.seriesData = resp.data.seriesData;
            }).catch(error => {
                console.error("Failed to fetch data:", error);
                this.toast.error("Failed ao carregar grafico.");
            });
        },
        async renderChart() {
            this.chart?.destroy();
            this.loadingChartProgress = true;
            await this.index();

            if (!this.seriesData || this.seriesData.length === 0) {
                this.loadingChartProgress = false;
                return;
            }
            if (this.dateRegisters?.length > 0) {
                this.dateStart = moment(this.dateRegisters[0]).format('YYYY-MM-DD');
                this.dateEnd = moment(this.dateRegisters[this.dateRegisters.length - 1]).format('YYYY-MM-DD');
            }
            const formattedDates = this.dateRegisters;
            const options = {
                series: this.seriesData,
                chart: {
                    type: 'bar',
                    height: '85%',
                    stacked: true,
                    toolbar: {
                        show: true,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: false,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: false,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        autoSelected: 'zoom'
                    },
                    zoom: {
                        enabled: true
                    },
                    selection: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        endingShape: "rounded",
                        borderRadius: 0,
                        dataLabels: {
                            total: {
                                enabled: true,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    }
                },
                xaxis: {
                    type: 'category',
                    tickPlacement: 'on',
                    categories: formattedDates,
                    labels: {
                        show: true,
                        formatter: (date) => {
                            if (!date) {
                                return '-'
                            }
                            date = date.split('-')
                            return `${date[2]}/${date[1]}/${date[0]}`;
                        },
                    }
                },
                legend: {
                    position: 'bottom',
                    offsetY: 10,
                    showForSingleSeries: true,
                },
                fill: {
                    opacity: 1
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }]
            };

            const el = document.getElementById('apex');
            this.chart = new ApexCharts(el, options);
            this.chart.render();
            this.loadingChartProgress = false;
        },
        graficResumClientAge() {
            this.loadingChartAge = true;
            this.chartAge?.destroy();
            Clients.getResumClientAge(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                resp.data.forEach(i => {
                    series.push(i.total);
                    labels.push(`${i.age_range} (${i.generation})`);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Pessoas por idade',
                        align: 'center',
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    colors: ['#00e396'],
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartAge = new ApexCharts(document.querySelector("#clientAge"), options);
                this.chartAge.render();
                this.loadingChartAge = false;
            })
        },
        graficResumClientReserveAge() {
            this.loadingChartClientReserveAge = true;
            this.chartClientReserveAge?.destroy();
            Clients.getResumClientReserveAge(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                resp.data.forEach(i => {
                    series.push(i.total);
                    labels.push(`${i.age_range} (${i.generation})`);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Clientes por idade',
                        align: 'center',
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartClientReserveAge = new ApexCharts(document.querySelector("#clientReserveAge"), options);
                this.chartClientReserveAge.render();
                this.loadingChartClientReserveAge = false;
            })
        },
        graficResumClientMaritalStatus() {
            this.loadingChartMaritalStatus = true;
            this.chartMaritalStatus?.destroy();
            Clients.getResumClientMaritalStatus(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i.total);
                    labels.push(i.marital_status);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Pessoas por estado civil',
                        align: 'center',
                    },
                    colors: ['#00e396'],
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };
                this.chartMaritalStatus = new ApexCharts(document.querySelector("#clientMaritalStatus"), options);
                this.chartMaritalStatus.render();
                this.loadingChartMaritalStatus = false;
            })
        },
        generateDistinctColors(count) {
            const colors = [];
            const hueStep = 360 / count;
            const startHue = 120;
            const hslToHex = (h, s, l) => {
                s /= 100;
                l /= 100;
                const k = n => (n + h / 30) % 12;
                const a = s * Math.min(l, 1 - l);
                const f = n =>
                        Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));
                return `#${[f(0), f(8), f(4)].map(x => x.toString(16).padStart(2, '0')).join('')}`;
            };
            for (let i = 0; i < count; i++) {
                const hue = (startHue + i * hueStep) % 360;
                colors.push(hslToHex(hue, 70, 50));
            }
            return colors;
        },
        graficResumClientState() {
            this.loadingChartState = true;
            this.chartState?.destroy();
            Clients.getResumClientState(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i.total);
                    labels.push(i.state_name);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '400px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Pessoas por Estados',
                        align: 'center',
                    },
                    colors: ['#00e396'],
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartState = new ApexCharts(document.querySelector("#clientState"), options);
                this.chartState.render();
                this.loadingChartState = false;
            })
        },
        graficResumClientReserveState() {
            this.loadingChartClientReserveState = true;
            this.chartClientReserveState?.destroy();
            Clients.getResumClientReserveState(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i.total);
                    labels.push(i.state_name);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '400px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Clientes por Estados',
                        align: 'center',
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartClientReserveState = new ApexCharts(document.querySelector("#clientReserveState"), options);
                this.chartClientReserveState.render();
                this.loadingChartClientReserveState = false;
            })
        },
        graficResumClientIncome() {
            this.loadingChartIncome = true;
            this.chartIncome?.destroy();
            Clients.getResumClientIncome(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i);
                })
                Object.keys(resp.data)?.forEach(i => {
                    labels.push(i);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '400px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Pessoas por Renda Mensal',
                        align: 'center',
                    },
                    colors: ['#00e396'],
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartIncome = new ApexCharts(document.querySelector("#clientIncome"), options);
                this.chartIncome.render();
                this.loadingChartIncome = false;
            })
        },
        graficResumClientReserveIncome() {
            this.loadingChartClientIncome = true;
            this.chartClientReserveIncome?.destroy();
            Clients.getResumClientReserveIncome(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i);
                })
                Object.keys(resp.data)?.forEach(i => {
                    labels.push(i);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '400px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Clientes por Renda Mensal',
                        align: 'center',
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartClientReserveIncome = new ApexCharts(document.querySelector("#clientReserveIncome"), options);
                this.chartClientReserveIncome.render();
                this.loadingChartClientIncome = false;
            })
        },
        graficResumClientCity() {
            this.loadingChartCity = true;
            this.chartCity?.destroy();
            Clients.getResumClientCity(this.allotmentId).then(resp => {
                let data = [];
                Object.values(resp.data)?.forEach(i => {
                    data.push({x: i.city_name, y: Math.log10(i.total + 1)})
                })
                const cor = this.generateDistinctColors(data.length);
                let heith = 0;
                if (data.length < 10) {
                    heith = 400;
                } else if (data.length < 25) {
                    heith = data.length * 25;
                } else if (data.length < 40) {
                    heith = data.length * 18;
                } else {
                    heith = data.length * 8;
                }
                var options = {
                    series: [{data: data}],
                    chart: {
                        height: `${heith}px`,
                        type: 'treemap',
                        toolbar: {
                            show: false,
                        },
                        events: {
                            dataPointSelection: (event, chartContext, config) => {
                                const dataIndex = config.dataPointIndex;
                                const seriesIndex = config.seriesIndex;
                                const clickedData = config.w.config.series[seriesIndex].data[dataIndex];
                                this.getChartNeighborhood(clickedData.x);
                            },
                            mounted: (chartContext) => setTimeout(this.adjustTreemapFontSizes(chartContext), 100),
                            updated: (chartContext) => this.adjustTreemapFontSizes(chartContext),
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (value) {
                                return Math.round(Math.pow(10, value) - 1);
                            }
                        }
                    },
                    title: {
                        text: 'Pessoas por Cidades',
                        align: 'center',
                    },
                    colors: cor,
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            colors: ['#000']
                        },
                    },
                    plotOptions: {
                        treemap: {
                            distributed: true,
                        }
                    },
                };
                this.chartCity = new ApexCharts(document.querySelector("#clientCity"), options);
                this.chartCity.render();
                this.loadingChartCity = false;
                this.createLegend(data, cor, 'legendCity');
            })
        },
        graficResumClientReserveCity() {
            this.loadingChartReserveClientCity = true;
            this.chartReserveClientCity?.destroy();
            Clients.getResumClientReserveCity(this.allotmentId).then(resp => {
                let data = [];
                Object.values(resp.data)?.forEach(i => {
                    data.push({x: i.city_name, y: Math.log10(i.total + 1)})
                })
                const cor = this.generateDistinctColors(data.length);
                let heith = 0;
                if (data.length < 10) {
                    heith = 400;
                } else if (data.length < 25) {
                    heith = data.length * 25;
                } else if (data.length < 40) {
                    heith = data.length * 18;
                } else {
                    heith = data.length * 8;
                }
                var options = {
                    series: [{data: data}],
                    chart: {
                        height: `${heith}px`,
                        type: 'treemap',
                        toolbar: {
                            show: false,
                        },
                        events: {
                            dataPointSelection: (event, chartContext, config) => {
                                const dataIndex = config.dataPointIndex;
                                const seriesIndex = config.seriesIndex;
                                const clickedData = config.w.config.series[seriesIndex].data[dataIndex];
                                this.getChartNeighborhood(clickedData.x);
                            },
                            mounted: (chartContext) => setTimeout(this.adjustTreemapFontSizes(chartContext, 'clientReserveCity'), 100),
                            updated: (chartContext) => this.adjustTreemapFontSizes(chartContext, 'clientReserveCity'),
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (value) {
                                return Math.round(Math.pow(10, value) - 1);
                            }
                        }
                    },
                    title: {
                        text: 'Clientes por Cidades',
                        align: 'center',
                    },
                    colors: cor,
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            colors: ['#000']
                        },
                    },
                    plotOptions: {
                        treemap: {
                            distributed: true,
                        }
                    },
                };
                this.chartReserveClientCity = new ApexCharts(document.querySelector("#clientReserveCity"), options);
                this.chartReserveClientCity.render();
                this.loadingChartReserveClientCity = false;
                this.createLegend(data, cor, 'legendReserveCity');
            })
        },
        adjustTreemapFontSizes(chartContext, id = 'clientCity', heith = null) {
            try {
                console.log(heith)
                if (!chartContext?.w?.globals?.series) {
                    console.warn("Estrutura do gráfico não encontrada");
                    return;
                }
                const seriesValues = chartContext.w.globals.series[0];
                const categoryLabels = chartContext.w.globals.categoryLabels;
                if (!seriesValues || !categoryLabels) {
                    console.warn("Dados da série não encontrados");
                    return;
                }
                const svg = document.querySelector(`#${id} svg`);
                if (!svg) return;
                const texts = svg.querySelectorAll('text.apexcharts-datalabel');
                texts.forEach((text, index) => {
                    if (index >= seriesValues.length || index >= categoryLabels.length) return;
                    let fontSize = '12px';
                    if (index < 30) {
                        fontSize = '90%';
                    } else if (index < 50) {
                        fontSize = '80%';
                    } else {
                        fontSize = '70%';
                    }
                    text.style.cssText = `font-size: ${fontSize} !important; font-weight: bold;`;
                    text.setAttribute('dominant-baseline', 'middle');
                    text.style.whiteSpace = 'nowrap';
                    if (index >= 23 && index < 41 && text.textContent.length > 17) {
                        text.textContent = text.textContent.substring(0, 17);
                    } else if (index >= 41 && text.textContent.length > 15) {
                        text.textContent = text.textContent.substring(0, 15);
                    }
                });
            } catch (error) {
                console.error("Erro ao ajustar fontes:", error);
            }
        },
        getChartNeighborhood(cityName) {
            let div = document.createElement('div');
            div.setAttribute('data-toggle', 'modal');
            div.setAttribute('data-target', '#customModalTwo');
            let body = document.getElementsByTagName('body')[0];
            body.appendChild(div);
            this.$store.commit('changeLoading', true);
            setTimeout(function () {
                div.click();
                div.remove();
            }, 100);
            let data = cityName.split('-');
            this.chartNeighborhood?.destroy();
            const legendContainer = document.getElementById('legendNeighborhod');
            if (legendContainer) legendContainer.innerHTML = '';
            if (this.typeGraficsResum === 'person'){
                Clients.getResumClientNeighborhood(this.allotmentId, data[0].trim(), data[1].trim()).then(resp => {
                    let data = [];
                    Object.values(resp.data)?.forEach(i => {
                        data.push({x: i.neighborhood, y: Math.log10(i.total + 1)})
                    })
                    const cor = this.generateDistinctColors(data.length);
                    let heith = 0;
                    if (data.length < 10) {
                        heith = 400;
                    } else if (data.length < 25) {
                        heith = data.length * 25;
                    } else if (data.length < 40) {
                        heith = data.length * 18;
                    } else {
                        heith = data.length * 8;
                    }
                    var options = {
                        series: [{data: data}],
                        chart: {
                            height: `${heith}px`,
                            type: 'treemap',
                            toolbar: {
                                show: false,
                            },
                            events: {
                                mounted: (chartContext) => setTimeout(this.adjustTreemapFontSizes(chartContext, 'clientNeighborhod', heith), 100),
                                updated: (chartContext) => this.adjustTreemapFontSizes(chartContext, 'clientNeighborhod', heith),
                            }
                        },
                        tooltip: {
                            y: {
                                formatter: function (value) {
                                    return Math.round(Math.pow(10, value) - 1);
                                }
                            }
                        },
                        title: {
                            text: 'Pessoas por Bairros',
                            align: 'center',
                        },
                        colors: cor,
                        dataLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                colors: ['#000']
                            },
                        },
                        plotOptions: {
                            treemap: {
                                distributed: true,
                            }
                        },
                    };
                    this.chartNeighborhood = new ApexCharts(document.querySelector("#clientNeighborhod"), options);
                    this.chartNeighborhood.render();
                    this.createLegend(data, cor, 'legendNeighborhod');
                    this.$store.commit('changeLoading', false);
                }).catch(() => this.$store.commit('changeLoading', false))
            }else {
                Clients.getResumClientReserveNeighborhood(this.allotmentId, data[0].trim(), data[1].trim()).then(resp => {
                    let data = [];
                    Object.values(resp.data)?.forEach(i => {
                        data.push({x: i.neighborhood, y: Math.log10(i.total + 1)})
                    })
                    const cor = this.generateDistinctColors(data.length);
                    let heith = 0;
                    if (data.length < 10) {
                        heith = 400;
                    } else if (data.length < 25) {
                        heith = data.length * 25;
                    } else if (data.length < 40) {
                        heith = data.length * 18;
                    } else {
                        heith = data.length * 8;
                    }
                    var options = {
                        series: [{data: data}],
                        chart: {
                            height: `${heith}px`,
                            type: 'treemap',
                            toolbar: {
                                show: false,
                            },
                            events: {
                                mounted: (chartContext) => setTimeout(this.adjustTreemapFontSizes(chartContext, 'clientNeighborhod', heith), 100),
                                updated: (chartContext) => this.adjustTreemapFontSizes(chartContext, 'clientNeighborhod', heith),
                            }
                        },
                        tooltip: {
                            y: {
                                formatter: function (value) {
                                    return Math.round(Math.pow(10, value) - 1);
                                }
                            }
                        },
                        title: {
                            text: 'Clientes por Bairros',
                            align: 'center',
                        },
                        colors: cor,
                        dataLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                colors: ['#000']
                            },
                        },
                        plotOptions: {
                            treemap: {
                                distributed: true,
                            }
                        },
                    };
                    this.chartNeighborhood = new ApexCharts(document.querySelector("#clientNeighborhod"), options);
                    this.chartNeighborhood.render();
                    this.createLegend(data, cor, 'legendNeighborhod');
                    this.$store.commit('changeLoading', false);
                }).catch(() => this.$store.commit('changeLoading', false))
            }
        },
        createLegend(data, cores, id) {
            const legendContainer = document.getElementById(id);
            legendContainer.innerHTML = '';
            data.forEach((item, index) => {
                const color = cores[index];
                const label = `${item.x} (${Math.round(Math.pow(10, item.y) - 1)})`;
                const itemDiv = document.createElement('div');
                itemDiv.style.display = 'inline-flex';
                itemDiv.style.alignItems = 'center';
                itemDiv.style.marginRight = '20px';
                itemDiv.style.fontWeight = 'bold';
                itemDiv.style.fontSize = '12px';
                const box = document.createElement('span');
                box.style.backgroundColor = color;
                box.style.width = '14px';
                box.style.height = '14px';
                box.style.display = 'inline-block';
                box.style.marginRight = '6px';
                box.style.borderRadius = '2px';
                const text = document.createElement('span');
                text.textContent = label;
                itemDiv.appendChild(box);
                itemDiv.appendChild(text);
                legendContainer.appendChild(itemDiv);
            });
        },
        graficResumClientProfession() {
            this.loadingChartProfession = true;
            this.chartProfession?.destroy();
            Clients.getResumClientProfession(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i.total);
                    labels.push(i.profession_name);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '400px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Pessoas por Profissões: Ranking 20 mais cadastradas',
                        align: 'center',
                    },
                    colors: ['#00e396'],
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };
                this.chartProfession = new ApexCharts(document.querySelector("#clientProfession"), options);
                this.chartProfession.render();
                this.loadingChartProfession = false;
            })
        },
        graficResumClientReserveProfession() {
            this.loadingChartReserveClientProfession = true;
            this.chartReserveClientProfession?.destroy();
            Clients.getResumClientReserveProfession(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i.total);
                    labels.push(i.profession_name);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '400px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Clientes por Profissões: Ranking 20 mais cadastradas',
                        align: 'center',
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };
                this.chartReserveClientProfession = new ApexCharts(document.querySelector("#clientReserveProfession"), options);
                this.chartReserveClientProfession.render();
                this.loadingChartReserveClientProfession = false;
            })
        },
        graficResumClientReserveMaritalStatus() {
            this.loadingChartClientReserveMaritalStatus = true;
            this.chartClientReserveMaritalStatus?.destroy();
            Clients.getResumClientReserveMaritalStatus(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                Object.values(resp.data)?.forEach(i => {
                    series.push(i.total);
                    labels.push(i.marital_status);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Clientes por estado civil',
                        align: 'center',
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                                total: {
                                    enabled: true,
                                }
                            }
                        }
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartClientReserveMaritalStatus = new ApexCharts(document.querySelector("#clientReserveMaritalStatus"), options);
                this.chartClientReserveMaritalStatus.render();
                this.loadingChartClientReserveMaritalStatus = false;
            })
        },
        graficResumClientSex() {
            this.loadingChartSex = true;
            this.chartSex?.destroy();
            Clients.getResumClientSex(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                resp.data.forEach(i => {
                    series.push(i.total);
                    labels.push(i.sex);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    colors: ['#00e396'],
                    title: {
                        text: 'Pessoas por gênero',
                        align: 'center',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartSex = new ApexCharts(document.querySelector("#clientSex"), options);
                this.chartSex.render();
                this.loadingChartSex = false;
            })
        },
        graficResumClientType() {
            this.loadingChartType = true;
            this.chartClientType?.destroy();
            Clients.getResumClientType(this.allotmentId).then(resp => {
                let series = [resp.data.fisical, resp.data.juridical];
                let labels = ['Física', 'Jurídica'];
                if (resp.data?.not_informed) {
                    labels.push('Não Informado');
                    series.push(resp.data.not_informed);
                }
                this.totalClient = series.reduce((acc, val) => acc + val, 0)
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    colors: ['#00e396'],
                    title: {
                        text: 'Pessoas por Tipo',
                        align: 'center',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },

                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartClientType = new ApexCharts(document.querySelector("#clientType"), options);
                this.chartClientType.render();
                this.loadingChartType = false;
            })
        },
        graficResumReserveClientType() {
            this.loadingChartClientReserveType = true;
            this.chartReserveClientType?.destroy();
            Clients.getResumClientReserveType(this.allotmentId).then(resp => {
                let series = [resp.data.fisical, resp.data.juridical];
                let labels = ['Física', 'Jurídica'];
                if (resp.data?.not_informed) {
                    labels.push('Não Informado');
                    series.push(resp.data.not_informed);
                }
                this.totalReserveClient = series.reduce((acc, val) => acc + val, 0);
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Clientes por Tipo',
                        align: 'center',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartReserveClientType = new ApexCharts(document.querySelector("#clientReserveType"), options);
                this.chartReserveClientType.render();
                this.loadingChartClientReserveType = false;
            })
        },
        graficResumClientReserveSex() {
            this.loadingChartReserveSex = true;
            this.chartReserveSex?.destroy();
            Clients.getResumClientReserveSex(this.allotmentId).then(resp => {
                let series = [];
                let labels = [];
                resp.data.forEach(i => {
                    series.push(i.total);
                    labels.push(i.sex);
                })
                var options = {
                    series: [{data: series}],
                    chart: {
                        height: '300px',
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    title: {
                        text: 'Clientes por gênero',
                        align: 'center',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            borderRadiusApplication: 'end',
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetX: 25,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            colors: ['#6c736c']
                        },
                    },
                    xaxis: {
                        categories: labels,
                    },
                };

                this.chartReserveSex = new ApexCharts(document.querySelector("#clientReserveSex"), options);
                this.chartReserveSex.render();
                this.loadingChartReserveSex = false;
            })
        },
        loadingGrafic(context) {
            if (context === 'progress' && this.loadingChartProgress) return 'display: flex; justify-content: center;';
            if (context === 'resumS' && this.loadingChartSex) return 'display: flex; justify-content: center;';
            if (context === 'resumT' && this.loadingChartType) return 'display: flex; justify-content: center;';
            if (context === 'resumA' && this.loadingChartAge) return 'display: flex; justify-content: center;';
            if (context === 'resumM' && this.loadingChartMaritalStatus) return 'display: flex; justify-content: center;';
            if (context === 'resumSt' && this.loadingChartState) return 'display: flex; justify-content: center;';
            if (context === 'resumCi' && this.loadingChartCity) return 'display: flex; justify-content: center;';
            if (context === 'resumPr' && this.loadingChartProfession) return 'display: flex; justify-content: center;';
            if (context === 'resumIn' && this.loadingChartIncome) return 'display: flex; justify-content: center;';
            if (context === 'resumSClient' && this.loadingChartReserveSex) return 'display: flex; justify-content: center;';
            if (context === 'resumAClient' && this.loadingChartClientReserveAge) return 'display: flex; justify-content: center;';
            if (context === 'resumMClient' && this.loadingChartClientReserveMaritalStatus) return 'display: flex; justify-content: center;';
            if (context === 'resumTClient' && this.loadingChartClientReserveType) return 'display: flex; justify-content: center;';
            if (context === 'resumStClient' && this.loadingChartClientReserveState) return 'display: flex; justify-content: center;';
            if (context === 'resumInClient' && this.loadingChartClientIncome) return 'display: flex; justify-content: center;';
            if (context === 'resumCiClient' && this.loadingChartReserveClientCity) return 'display: flex; justify-content: center;';
            if (context === 'resumPrClient' && this.loadingChartReserveClientProfession) return 'display: flex; justify-content: center;';
            return '';
        },
    }

}
</script>

<style>
.apexcharts-legend {
    justify-content: start !important;
}

#clientCity .apexcharts-treemap-rect {
    cursor: pointer;
}
</style>
